export enum RecordingStatus {
  Idle = 'Idle',
  Recording = 'Recording',
  Playing = 'Playing',
  Paused = 'Paused',
  Initializing = 'Initializing',
}

export type RecordType = { data: Blob; duration: number }
